import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Validation } from "../../../../_helpers/validation/Validation";
import { LoginServices } from "../../../../_services/Arya2.0/Login/LoginServices";
import Button from "../CommonComponents/Button";

import HeadLines from "../CommonComponents/HeadLines";
import InputMobileNumber from "../CommonComponents/InputMobileNumber";
import { isNumberOnly } from "../CommonFunctions/Function";
import { VERIFY_NUMBER_CTA_CLICKED } from "../GATracker3.0/constants";
import { eventTracker } from "../GATracker3.0/eventTracker";
import { userDetail } from "../GetInTouch/constant";
import { isMobile } from "../helperFunc";
import style from "./style.module.css";
import { setOTPUID } from "../Redux/UserInfo/actions";
import { useDispatch } from "react-redux";
const initiate = {
  number: "",
};

const NumberEntry = (props) => {
  const [data, setData] = useState({
    ...initiate,
    number: props.mobileNumber,
  });
  const [error, setError] = useState("");
  const location = useLocation();
  const { setPopUpClosed = () => {} } = props;

  const [disable, setDisable] = useState(true);
  const [buttonDisable, setButtonDisable] = useState(true);
  const history = useHistory();
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.mobileNumber) {
      setDisable(false);
      setButtonDisable(false);
    } else {
      setDisable(true);
      setButtonDisable(true);
    }
  }, []);

  //Focus the input field while popup is open
  useEffect(() => {
    inputRef.current.focus();
  }, []);
  const onChange = (e) => {
    const { name, value } = e.target;
    const isNumberValid = value ? isNumberOnly(value) : true;

    if (value.toString().length <= 10 && isNumberValid) {
      setData((prev) => ({ ...prev, [name]: value }));
      if (e.target.value) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }
    if (value.toString().length >= 10 && isNumberValid) {
      setButtonDisable(false);
      if (!props.isDesktop) inputRef.current.blur();
    } else {
      setButtonDisable(true);
    }
  };
  const sendOtp = async () => {
    let errobj = {};
    errobj = Validation(data, userDetail());
    setError(errobj);
    let flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      let dataObj = {
        mobile: data.number,
      };
      props.setIsLoading(true);
      let response = await LoginServices.sendOTPOnMobile(dataObj);
      props.setIsLoading(false);
      if (response) {
        localStorage.removeItem("ssecretKey");
        props.setMobileNumber(data.number);
        dispatch(
          setOTPUID({
            otpUid: response.data?.data?.uid,
          })
        );
        props.setStepNo(1);
      }
      //   setLoader(false)
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      // Call your function here
      sendOtp();
    }
  };
  return (
    <>
      <HeadLines
        className={`font-weight600 
                        ${
                          props.isDesktop
                            ? ` font-size16
                        line-height19`
                            : ` font-size12
                        line-height14 `
                        } letterSpacing025 colorDark9 padding-bottom12`}
        text={"Please enter your 10 digit mobile number"}
      />
      <InputMobileNumber
        className1={`mobile-number-entry ${
          style["border-width"]
        } boxRadius4 lightBorder padding-top12 padding-bottom12 ${
          style["padding-left50"]
        }  width-100   ${
          props.isDesktop
            ? ` font-size16
        line-height19`
            : ` font-size14
        line-height16 `
        } letterSpacing05 ${
          disable ? "colorDark9 font-weight400" : "font-weight500"
        }`}
        className2={` ${
          disable ? "colorDark9 font-weight400" : "font-weight500"
        } ${style["positionTopBottom"]}   ${
          props.isDesktop
            ? ` font-size16
        line-height19`
            : ` font-size14
        line-height16 `
        } letterSpacing05 `}
        value={data.number}
        onChange={onChange}
        name="number"
        showError={error.number}
        errorClassName={isMobile && `margin-top4`}
        inputRef={inputRef}
        onkeydown={handleKeyPress}
      />
      <HeadLines
        className={`font-weight400  padding-top12
        ${
          props.isDesktop
            ? ` font-size14
        line-height16 `
            : ` font-size10
        line-height12 `
        } letterSpacing025 colorDark9 padding-bottom16`}
        text={"A 6 digit OTP will be sent via SMS to verify your mobile number"}
      />

      {props.appLogin ? (
        <>
          <Button
            onClick={() => {
              setPopUpClosed("after");
              eventTracker("event", VERIFY_NUMBER_CTA_CLICKED, {
                pagename:
                  location.pathname === "/" ? "homepage" : location.pathname,
                phone_number: data?.number,
              });

              !buttonDisable && sendOtp();
            }}
            className={` ${
              !buttonDisable ? "backAccent4" : style["nonCertifiedBack"]
            } font-weight500 
        font-size14
        line-height16 letterSpacing0125 padding12 boxRadius6 textColorWhite width-100 margin-right8 `}
            title="Get OTP"
          />
        </>
      ) : (
        ""
      )}

      <div
        className={`font-weight400 
        ${
          props.isDesktop
            ? ` font-size14
        line-height16 `
            : ` font-size10
        line-height12 `
        } letterSpacing025 padding-top16 `}
      >
        <HeadLines
          className={` colorDark9 display-inline-block`}
          text={"Facing trouble while logging in? Call us on"}
        />
        <div
          className={`${style["blueColor"]} padding-left4 display-inline-block cursorPointer`}
          onClick={() => {
            window.location.href = "tel:+91-9015260260";
          }}
        >
          +91-9015260260
        </div>
      </div>

      <div
        className={`d-flex font-weight400 
        ${
          props.isDesktop
            ? ` font-size14
        line-height16 `
            : ` font-size10
        line-height12 `
        } letterSpacing025 padding-top8 `}
      >
        <HeadLines
          className={` colorDark9 `}
          text={"By logging in, you agree to arya.ag’s"}
        />
        <HeadLines
          className={`${style["blueColor"]} padding-left4 cursorPointer`}
          text={"Terms of Services"}
          onClick={() => history.push("/terms-condition")}
        />
      </div>
      {props.appLogin ? (
        ""
      ) : (
        <>
          <div className={`${style["lightBorderTop2"]}`}></div>
          <div
            className={
              props.isDesktop
                ? "d-flex justify-content-center padding-top4"
                : ""
            }
          >
            <Button
              onClick={() => {
                setPopUpClosed("after");
                eventTracker("event", VERIFY_NUMBER_CTA_CLICKED, {
                  pagename:
                    location.pathname === "/" ? "homepage" : location.pathname,
                  phone_number: data?.number,
                });
                !buttonDisable && sendOtp();
              }}
              className={` ${
                !buttonDisable
                  ? "backAccent3"
                  : props.isDesktop
                  ? style["buttonBackground"]
                  : style["nonCertifiedBack"]
              } font-weight500 
        font-size14
        line-height16 letterSpacing0125 padding12 boxRadius6 textColorWhite ${
          props.isDesktop ? ` ${style["width285"]}  ` : `width-100`
        } margin-right8 `}
              title="Get OTP"
            />
          </div>
        </>
      )}
    </>
  );
};
export default NumberEntry;
